module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Fb-Ge-Hc-Ia.235591a8.png";